import ReactDOM from 'react-dom';
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { App } from './App';

const container = document.getElementById('root');

ReactDOM.render(<App />, container);
